"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupHisaiList = void 0;
var _ExpandList = _interopRequireDefault(require("01_core/components/layout/ExpandList"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CSwitch = _interopRequireDefault(require("01_core/components/materials/CSwitch"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HeaderLabel = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    paddingTop: theme.spacing(1)
  };
});
const ExpandSwitch = (0, _styles.styled)('div')(() => ({
  '& label': {
    height: '27px'
  }
}));
const BoldTypography = (0, _styles.styled)(_Typography.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body2.fontSize
  };
});
const SELECT_COL_WIDTH = 110;
class GroupHisaiList extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupHisaiKbnList: [],
      checked: ''
    };
    props.callAPI(_APIs.GROUPHISAI_KBN).then(response => {
      if (response.status === _APIs.STATUS.SUCCESS) {
        if (response.data) {
          this.setState({
            groupHisaiKbnList: response.data
          });
        }
      }
    });
  }
  render() {
    const {
      intl,
      callAPI
    } = this.props;
    const {
      groupHisaiKbnList
    } = this.state;
    const columns = [{
      title: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_POST
      }),
      width: 'auto',
      expandColumn: true
    }, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_DISPLAY_TARGET
      }),
      width: SELECT_COL_WIDTH
    }];
    const changeSwitch = (selectGrouphisaiKbnCd, selectDispSet) => {
      const sendData = {
        grouphisaiKbnCd: selectGrouphisaiKbnCd,
        dispSet: selectDispSet
      };
      groupHisaiKbnList.forEach(item => {
        if (item.grouphisaiKbnCd === selectGrouphisaiKbnCd) {
          item.dispSet = selectDispSet;
          this.setState({
            checked: selectDispSet
          });
        }
      });
      callAPI(_APIs.HOME_DISPLAY_SETTING_SET_GROUPHISAI, sendData).then();
    };
    const createRowData = dataList => {
      const exp = [];
      dataList.forEach(data => {
        exp.push(getRowData(data));
      });
      return exp;
    };
    const getRowData = data => {
      const rowData = {};
      const selectComponent = data.dispOnlyFlg === _CodeConsts.CODE.FLG_VALUE.CODE_0 ? /*#__PURE__*/_react.default.createElement(ExpandSwitch, null, /*#__PURE__*/_react.default.createElement(_CSwitch.default, {
        checked: data.dispSet,
        onChange: bool => changeSwitch(data.grouphisaiKbnCd, bool)
      })) : '';
      const sourceComponent = data.expand === _CodeConsts.CODE.FLG_VALUE.CODE_1 ? /*#__PURE__*/_react.default.createElement(BoldTypography, null, data.grouphisaiKbnName) : /*#__PURE__*/_react.default.createElement(_Typography.default, {
        variant: "body2"
      }, data.grouphisaiKbnName);
      rowData.rowComponents = [sourceComponent, selectComponent];
      rowData.depth = data.depth;
      if (data.expand === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
        rowData.expandStatus = data.expsts === _CodeConsts.CODE.FLG_VALUE.CODE_1;
      }
      return rowData;
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HeaderLabel, null, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_GROUP_DAMAGE_INFOMATION_DISPLAY_TARGET
      })
    })), /*#__PURE__*/_react.default.createElement(_ExpandList.default, {
      columns: columns,
      rowData: createRowData(groupHisaiKbnList)
    }));
  }
}
exports.GroupHisaiList = GroupHisaiList;
var _default = exports.default = (0, _CallAPI.withCallAPI)(GroupHisaiList);